import Vue from "vue";
import VueRouter from "vue-router";
import Home from "./views/Home.vue";
import Login from "./views/Login.vue";
import Logout from "./views/Logout.vue";
import Members from "./views/Members.vue";
import Access from "./views/Access.vue"
import Cart from "./views/Cart.vue"
import Courses from "./views/Courses.vue"
import Complete from "./views/Complete.vue"
import BioDemo from "./views/BioDemo.vue"
import Registration from "./views/Registration.vue"
import Application from "./views/Application.vue"
import Accept from "./views/Accept.vue"
import Configure from "./views/Configure.vue"
import Cancel from "./views/Cancel.vue"
import Report from "./views/Report.vue"
import KanBan from "./views/kanban.vue"


Vue.use(VueRouter);

const routes = [
  {
    path: "/kanban",
    name: "kanban",
    component: KanBan
  },
  {
    path: "/cancel",
    name: "cancel",
    component: Cancel
  },
  {
    path: "/report",
    name: "report",
    component: Report
  },  
  {
    path: "/registration",
    name: "registration",
    component: Registration
  },
  {
    path: "/application",
    name: "application",
    component: Application
  },
  {
    path: "/accept",
    name: "accept",
    component: Accept
  },
  {
    path: "/configure",
    name: "configure",
    component: Configure
  },
  {
    path: "/",
    name: "home",
    component: Home
  },
  {
    path: "/login",
    name: "login",
    component: Login
  },
  {
    path: "/logout",
    name: "logout",
    component: Logout
  },
  {
    path: "/members",
    name: "members",
    component: Members
  },
  {
    path: "/access",
    name: "access",
    component: Access
  },
  {
    path: "/biodemo",
    name: "biodemo",
    component: BioDemo
  },
  {
    path: "/cart",
    name: "cart",
    component: Cart
  },
  {
    path: '/complete',
    name: "complete",
    component: Complete
  },
  {
    path: "/courses",
    name: "courses",
    component: Courses
  }
];

const router = new VueRouter({
  routes
});

export default router;
